import cx from 'clsx';
import { Swiper as SwiperType } from 'swiper';
import { Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './HorizontalSlider.module.scss';

interface HorizontalSliderProps<T> {
  data: T[];
  handleSwiper?: (swiper: SwiperType) => void;
  renderItem: (item: T, index: number) => React.ReactNode;
  customStyles?: {
    container?: string;
    slide?: string;
  };
  maxSlideWidth?: number;
  slidesPerView?: number | 'auto';
}

const HorizontalSlider = <T,>({
  data,
  handleSwiper,
  renderItem,
  customStyles,
  maxSlideWidth,
  slidesPerView = 'auto',
}: HorizontalSliderProps<T>) => (
  <Swiper
    slidesPerView={slidesPerView}
    spaceBetween={24}
    slidesPerGroup={1}
    modules={[Mousewheel]}
    onSwiper={handleSwiper}
    mousewheel={{ forceToAxis: true, releaseOnEdges: true }}
    watchSlidesProgress
    className={cx(styles.container, customStyles?.container, { [styles.containerAuto]: slidesPerView === 'auto' })}
  >
    {data.map((item, index) => (
      <SwiperSlide
        key={`${index + 1}`}
        className={cx(styles.slide, customStyles?.slide)}
        style={{ maxWidth: maxSlideWidth }}
      >
        {renderItem(item, index)}
      </SwiperSlide>
    ))}
  </Swiper>
);

export default HorizontalSlider;
